<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Avaliação da ordem</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para aprovação ou recusa.
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <ng-container *ngIf="boobleModalData.type == 'cancel'">
            <div class="col-warning">
              <div class="d-flex justify-content-between margin-mb-16">
                <div class="d-flex gap-10 align-items-center">
                  <img
                    src="assets/image/information-icon.svg"
                    width="20"
                    height="20"
                    style="flex-shrink: 0"
                  />

                  <p class="text-p mb-0">
                    <strong class="weight-500">Cancelamento da ordem</strong>
                  </p>
                </div>
              </div>

              <p class="text-information">
                O cancelamento da ordem não poderá ser desfeito e o cliente não
                poderá ter mais nenhuma ação nela.
              </p>
            </div>
          </ng-container>

          <form [formGroup]="reprovedForm">
            <div class="content-repproved">
              <div class="form-row mg-bottom-8">
                <p class="label-motivo">
                  {{
                    boobleModalData.type == "repprove"
                      ? "Motivo da reprovação"
                      : "Motivo do cancelamento"
                  }}<span class="text-danger"> *</span>
                </p>
              </div>
              <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>{{
                    boobleModalData.type == "repprove"
                      ? "Descrição da reprovação"
                      : "Descrição do cancelamento"
                  }}</mat-label>
                  <textarea
                    formControlName="reprovedMsg"
                    required
                    matInput
                  ></textarea>
                </mat-form-field>
              </div>
              <div class="form-row">
                <span
                  class="text-danger"
                  *ngIf="
                    reprovedFormControl.reprovedMsg.touched &&
                    reprovedFormControl.reprovedMsg.errors?.required
                  "
                >
                  {{
                    boobleModalData.type == "repprove"
                      ? "Motivo da reprovação obrigatório"
                      : "Motivo do cancelamento obrigatório"
                  }}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          type="button"
          [style.width]="'134px'"
          class="btn-outline-dark btn"
          (click)="closeModal()"
          type="button"
        >
          Voltar
        </button>
        <button
          type="button"
          (click)="sendReprove()"
          [disabled]="reprovedForm.invalid || loading"
          class="btn-footer btn btn-dark-primary-blue"
          type="button"
        >
          {{
            boobleModalData.type == "repprove"
              ? "Finalizar avaliação"
              : "Cancelar a ordem"
          }}
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </div>
  </div>
</div>
